module.exports = __webpack_public_path__ + "img/icon-intestine-green.d96a74db.svg";